import { memo } from 'react'
import { twMerge } from 'tailwind-merge'

interface ViewGroupLabelProps {
  children: string
  /** The first label sits flush against the header; later ones open their group. */
  isFirst?: boolean
  className?: string
}

/**
 * The day/section label above a run of rows in a full-list View — "Today",
 * "Yesterday", "Pinned" (Figma `7534:35175`).
 */
export const ViewGroupLabel = memo(function ViewGroupLabel({ children, isFirst, className }: ViewGroupLabelProps) {
  return (
    <p
      className={twMerge(
        'text-foreground-secondary type-ui-xs flex items-end px-3 pb-[2px] font-medium',
        isFirst ? 'pt-0' : 'pt-3',
        className,
      )}
    >
      {children}
    </p>
  )
})
